// utils/fallbackLocation.js
export const getIPLocation = async () => {
  try {
    // Use backend endpoint instead of direct API call to avoid CORS issues
    const baseURL =
      process.env.REACT_APP_BACKEND_URL || "http://localhost:5001";
    const response = await fetch(`${baseURL}/api/location/ip-location`);
    if (!response.ok) throw new Error("Failed to fetch IP location");
    const result = await response.json();

    if (!result.success) {
      throw new Error(result.message || "IP location lookup failed");
    }

    return {
      latitude: result.data.latitude,
      longitude: result.data.longitude,
      city: result.data.city,
      country: result.data.country,
    };
  } catch (error) {
    console.error("IP-based location fallback failed", error);
    return null;
  }
};
